module.exports = __webpack_public_path__ + "static/img/M-715-MOLVENO.dae92bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-715-MOLVENO.png
// module id = UbVp
// module chunks = 0